import type { PPProviderBehavior } from '../types';
import { CISConfigType } from '../../typegen/cis-config-type';

export const paymentusPPBehavior: PPProviderBehavior = {
	label: 'Paymentus',
	requiresPrepareTransaction: false,
	cardPrepareAutoStart: false,
	getReceiptInvoiceNumber(item, cartId, obscure) {
		if (cartId) return cartId;
		return obscure ? (item.obscuredItemNumber ?? item.itemNumber) : item.itemNumber;
	},
	getTestPanelConfig(cisType) {
		return {
			show: cisType !== CISConfigType.Paymentus,
			altText: 'Paymentus',
		};
	},
	cardDeviceDisplayName: '',
	requiresPayorInformation: false,
};
